<template>
  <div id="app" class="bg-background">
    <router-view />
    <loading-overlay />
    <modal />
  </div>
</template>

<script>
import LoadingOverlay from "@/components/LoadingOverlay";
import Modal from '@/components/modals/Modal'

export default {
  components: {
    LoadingOverlay,
    Modal
  },
  beforeCreate() {
    this.$store.dispatch('registerResizeListener')
  }
}
</script>

<style>
</style>
